module.exports = __webpack_public_path__ + "img/s-kurva_bild.fbf58b80.jpg";